<div class="bh-container">
  <ng-container *ngIf="interface.type == 'default'"  [ngTemplateOutlet]="FOOTER_DEFAULT"></ng-container>
  <ng-container *ngIf="interface.type == 'public'"  [ngTemplateOutlet]="FOOTER_PUBLIC"></ng-container>
  <ng-container *ngIf="interface.type == 'private'"  [ngTemplateOutlet]="FOOTER_PRIVATE"></ng-container>
  <ng-container *ngIf="interface.type == 'protected'"  [ngTemplateOutlet]="FOOTER_PROTECTED"></ng-container>
  <ng-container *ngIf="interface.type == 'task'"  [ngTemplateOutlet]="FOOTER_TASK"></ng-container>
</div>

<ng-template #FOOTER_DEFAULT >

</ng-template>
<ng-template #FOOTER_PUBLIC >
    <div class="bh-footer-about">
        <p>About ArgoPrep</p>
        <span>ArgoPrep is your go-to partner for K-8 learning success! As a trusted supplementary curriculum provider, we’ve helped over a million students (and counting!) build confidence, master skills, and love learning. Whether it’s math, reading, or test prep, our award-winning <a href="https://argoprep.online/store/">workbooks</a>, online resources, and engaging lessons are designed to make learning fun and effective.<br> Loved by <a href="https://argoprep.online/">homeschooling</a> families and classrooms alike, we’re proud to support learners nationwide. </span>
    </div>
    <ul class="bh-footer-lists">
        <li class="bh-footer-lists-title">Menu</li>
        <li><a class="bh-footer-list-item" routerLink="/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
            <span>{{'nav.home' | transloco}}</span>
        </a></li>
        <li><a class="bh-footer-list-item" routerLink="/k12/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
            <span>{{'nav.k12' | transloco}}</span>
        </a></li>
        <li><a class="bh-footer-list-item" routerLink="/shsat/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
            <span>{{'nav.shsat' | transloco}}</span>
        </a></li>
    </ul>
    <ul class="bh-footer-lists">
        <li class="bh-footer-lists-title">Resources</li>
        <li><a class="bh-footer-list-item" routerLink="/blog/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
      <span>{{'nav.blog' | transloco}}</span>
    </a></li>
        <li><a class="bh-footer-list-item" routerLink="/worksheets/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
            <span>{{'nav.worksheets' | transloco}}</span>
        </a></li>
        <li><a class="bh-footer-list-item" routerLink="/store/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
            <span>{{'nav.store' | transloco}}</span>
        </a></li>
  </ul>
    <div class="bh-footer-lists">
    <div class="bh-footer-lists-title">{{'components.footer.titles.contacts' | transloco}}</div>
    <div class="bh-footer-list-item">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25" />
      </svg>
      <a rel="nofollow noreferrer noopener" href="mailto:info@argoprep.com"><span>info@argoprep.com</span></a>
    </div>
    <div class="bh-footer-list-item">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
      </svg>
      <a rel="nofollow noreferrer noopener" href="tel:+1929-500-ARGO"><span>+1 929-500-ARGO</span></a>
    </div>
    <div class="bh-footer-lists-title mt-4">Follow us on social networks:</div>
    <ul class="bh-footer-list-item bh-footer-list-item-social">
      <li>
        <a rel="nofollow noreferrer noopener" href="https://www.facebook.com/ArgoPrepK8" target="_blank" aria-label="Facebook">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
          </svg>
        </a>
      </li>
      <li>
        <a rel="nofollow noreferrer noopener" href="https://t.me/s/argoprep" target="_blank" aria-label="Telegram">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" class="w-5 h-5">
            <path fill="currentColor" d="M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"/>
          </svg>
        </a>
      </li>
      <li>
        <a rel="nofollow noreferrer noopener" href="https://www.youtube.com/@argoprepedu" target="_blank" aria-label="YouTube">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
          </svg>
        </a>
      </li>
      <li>
        <a rel="nofollow noreferrer noopener" href="https://www.instagram.com/argoprep_edu/" target="_blank" aria-label="Instagram">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </a>
      </li>
    </ul>
  </div>
    <div class="bh-footer-bottom">
        <div class="bh-footer-bottom-menu">
            <a class="bh-footer-list-item" routerLink="/terms/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
                <span>{{'nav.terms' | transloco}}</span>
            </a>
            <p>|</p>
            <a class="bh-footer-list-item" routerLink="/privacy-policy/" routerLinkActive="bh-footer-list-item-active" [routerLinkActiveOptions]="{exact: true}" rel="nofollow">
                <span>{{'nav.privacy-policy' | transloco}}</span>
            </a>
        </div>
        <div class="bh-footer-copyright-text mt-auto flex flex-col">
            <span>{{'components.footer.copyright.copy' | transloco}}</span>
        </div>
    </div>
</ng-template>
<ng-template #FOOTER_PRIVATE>

</ng-template>
<ng-template #FOOTER_PROTECTED>

</ng-template>
<ng-template #FOOTER_TASK>

</ng-template>
